// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__19X18","cell":"ColumnAccessor_cell__1qcTq","firstCellAccent":"ColumnAccessor_firstCellAccent__TETAy"};